export default __webpack_public_path__ + "static/media/vegW3.72e7e0a9.png";